// Utility for i18n translations in TypeScript/React components
export function t(key: string, defaultValue: string = ''): string {
  const i18n = (window as any).I18n;
  if (!i18n || typeof i18n.t !== 'function') {
    return defaultValue || key;
  }
  return i18n.t(key, defaultValue);
}

export function getLocale(): string {
  const i18n = (window as any).I18n;
  return i18n?.locale || 'en';
}

